import React from 'react';
import { Card, Grid, Skeleton } from '@/theme/index';
import { useScreenSize } from '@/utils/index';

export function ContactResultSkeleton() {
  const { isMobile } = useScreenSize();

  return (
    <Card
      variant="outlined"
      data-testid="contact-result-skeleton"
      sx={(theme) => ({
        width: '100%',
        marginBottom: theme.spacing(1.5),
        padding: theme.spacing(3),
        borderRadius: 1,
      })}
    >
      <Grid
        container
        alignItems={isMobile ? 'normal' : 'flex-start'}
        justifyContent="space-between"
        spacing={isMobile ? 2 : 0}
        direction={isMobile ? 'column' : 'row'}
      >
        <Grid item xs={3}>
          <Skeleton
            variant="rounded"
            width={isMobile ? '200px' : '100%'}
            height={20}
            sx={{ mb: 1 }}
          />
          <Skeleton
            variant="rounded"
            width={isMobile ? '120px' : '60%'}
            height={16}
          />
        </Grid>
        <Grid item xs={2}>
          <Skeleton
            variant="rounded"
            width={isMobile ? '160px' : '80%'}
            height={16}
            sx={{ mb: 1 }}
          />
          <Skeleton
            variant="rounded"
            width={isMobile ? '140px' : '70%'}
            height={16}
          />
        </Grid>
        <Grid item xs={2}>
          <Skeleton
            variant="rounded"
            width={isMobile ? '160px' : '80%'}
            height={16}
          />
        </Grid>
        <Grid item xs={3}>
          <Skeleton variant="rounded" width="100%" height={40} />
        </Grid>
      </Grid>
    </Card>
  );
}
